import { render } from "./OwnedNftsPanel.vue?vue&type=template&id=92fb4cac&scoped=true"
import script from "./OwnedNftsPanel.vue?vue&type=script&lang=js"
export * from "./OwnedNftsPanel.vue?vue&type=script&lang=js"

import "./OwnedNftsPanel.vue?vue&type=style&index=0&id=92fb4cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92fb4cac"]])

export default __exports__